import { __decorate } from "tslib";
import { MembershipFrontendSharedModule, MembershipStatusMessageComponent } from '@common/membership/frontend-shared';
import { AccessGuard, accessGuardData, FrontendFeaturePlugin, provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { UserRole } from '@core/shared/access';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let MembershipFrontendFeature = /*#__PURE__*/(() => {
  let MembershipFrontendFeature = class MembershipFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/membership/frontend","featureId":"common-membership"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        profile: [{
          label: 'Mitgliedschaft',
          routerLink: './membership',
          simpleAbilityCheck: {
            allow: [[UserRole.REGISTERED, "Feature.common-membership.View"]]
          }
        }]
      });
      functionality.defineWidgets([{
        type: 'Content',
        id: 'MembershipStatusMessageComponent',
        positionIds: ['content-dashboard-top'],
        component: MembershipStatusMessageComponent
      }]);
      functionality.defineRouterLinkRedirects([
      // TODO: this is not a perfect solution.
      // membership should instead provide a registration-AuthStrategy, allowing it to display its mmodule right on user/registration.
      {
        matcher: '/user/registration',
        redirect: (path, tree, resolve) => {
          // this redirect is a bit more complex. user/registration may have a referrerCode query param that we need to include in redirect
          return resolve('membership-registration', {
            referrerCode: tree.queryParams.referrerCode || null
          });
        },
        type: 'Replace'
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMembershipFrontendFeature_BaseFactory;
        return function MembershipFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵMembershipFrontendFeature_BaseFactory || (ɵMembershipFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MembershipFrontendFeature)))(__ngFactoryType__ || MembershipFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MembershipFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'membership',
          loadChildren: () => import('./membership-frontend.module').then(m => m.MembershipFrontendModule)
        }]), provideFeatureAddonRoutes([{
          useAddonSlot: 'user/profile',
          path: 'membership',
          canActivate: [AccessGuard],
          data: {
            ...accessGuardData({
              allow: [[UserRole.REGISTERED, "Feature.common-membership.View"]]
            })
          },
          loadChildren: () => import('./profile-integration/profile-integration.module').then(m => m.MembershipProfileIntegrationModule)
        }])],
        imports: [MembershipFrontendSharedModule, MembershipFrontendSharedModule]
      });
    }
  };
  MembershipFrontendFeature = __decorate([ClassName("MembershipFrontendFeature")], MembershipFrontendFeature);
  return MembershipFrontendFeature;
})();
export { MembershipFrontendFeature };